import "ng-tags-input/build/ng-tags-input.min.js";

export default 'ngTagsInput';